import _ from 'underscore';

// @ts-expect-error
import * as digest from 'assembly/_digest';
// @ts-expect-error
import * as gibson from 'assembly/_gibson';
import * as goldenGate from 'assembly/_golden-gate';
// @ts-expect-error
import {basePlugin} from 'assembly/_shared';
import {Sequence as BioJSSequence} from 'BioJS';
import {Model as BioJSSequencePrimer} from 'biojs/SequencePrimer';
import {Sequence, Selection} from 'components/Sequence';
import {ASSEMBLY_TYPE} from 'constants/AssemblyConstants';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import {BufferState} from 'Navigation';

import {Assembly} from './AssemblyModels';

export interface AssemblyPlugin {
  assemblyType: ASSEMBLY_TYPE | null;
  attachTabs: (sequence: Sequence, buffer: BufferState) => void;
  checkAssembly: (assembly: Assembly) => {warnings: Array<string>; errors: Array<string>};
  // Returns an array of [color, 5' start, 3' start]
  getFragmentResultPieces: (sequence: BioJSSequence) => Array<[string, number, number]>;
  isFlankingPrimer: (sequence: BioJSSequence, primer: BioJSSequencePrimer | SequencePrimer) => boolean;
  canDelete: (sequence: BioJSSequence, selection: Selection, errback: (message: string) => void) => boolean;
  canEditSelection: (
    sequence: BioJSSequence,
    selection: Selection,
    errback: (message: string) => void
  ) => boolean;
  canReplace: (
    sequence: BioJSSequence,
    selection: Selection,
    bases: string,
    errback: (message: string) => void
  ) => boolean;
  didDelete: (
    sequence: BioJSSequence,
    selection: Selection,
    deletionLength: number,
    callback: (message: string) => void,
    errback: (message: string) => void
  ) => void;
  didInsert: (
    sequence: BioJSSequence,
    insertPos: number,
    bases: string,
    callback: (message: string) => void,
    errback: (message: string) => void
  ) => void;
  didReplace: (
    sequence: BioJSSequence,
    selection: Selection,
    bases: string,
    callback: (message: string) => void,
    errback: (message: string) => void
  ) => void;
  shouldOpenBioJSSequenceFiles: () => boolean;
}

const PLUGINS: Array<AssemblyPlugin> = [basePlugin, digest.plugin, gibson.plugin, goldenGate.plugin];
const PLUGIN_MAP: {
  null: AssemblyPlugin;
  [ASSEMBLY_TYPE.DIGEST]: AssemblyPlugin;
  [ASSEMBLY_TYPE.GIBSON]: AssemblyPlugin;
  [ASSEMBLY_TYPE.GOLDEN_GATE]: AssemblyPlugin;
} = _.object(PLUGINS.map((plugin) => [plugin.assemblyType, plugin]));

function of_(sequence: BioJSSequence): AssemblyPlugin {
  return for_(sequence.assemblyType()!);
}

function for_(assemblyType: ASSEMBLY_TYPE | null): AssemblyPlugin {
  let assemblyTypeString: ASSEMBLY_TYPE | 'null';
  // TODO For now, standardizes null, undefined to null, but after Part 2 there won't be undefined
  if (assemblyType == null) {
    // basePlugin has a null assemblyType, which is coerced to the string "null" as a key in PLUGIN_MAP
    assemblyTypeString = 'null';
  } else {
    assemblyTypeString = assemblyType;
  }
  const plugin = PLUGIN_MAP[assemblyTypeString];
  if (plugin == null) {
    throw new Error(`Unexpected assembly type: ${assemblyTypeString}`);
  }
  return plugin;
}

export default {
  of: of_,
  for: for_,
  digest,
  gibson,
  goldenGate,
};
